import { gql } from '@apollo/client';
import { gql as graphql } from '@api/gql';

export const USER = graphql(/*GraphQL*/`
  query UserSession {
    UserSession {
      session {
        userId
        cynergyId
        accountId
        roleId
        role
        staffRelationId
        organizationId
        locationId
        locationName
        availableLocations {
          assignment_id
          location_id
          location {
            alias
          }
        }
        email
        userType
        phone
        lastName
        firstName
        username
        authnetProfileId
        practitionerId
        paymentProfiles @client {
          ...PaymentProfileCoreFragment
        }
        address {
          addressLine1
          addressLine2
          city
          state
          zip
          formattedAddress
          placeId
          isDefault
        }
        defaultPage
        firstLogin
        twoFactorEnabled
        twoFactorMethod
        photo
      }
      permissions
    }
  }
`);

export const GET_USER_SESSION_IP = gql`
  query UserSessionIP {
    UserSessionIP {
      region
      state
      city
      zip
      lat
      lng
    }
  }
`;

export const GET_USER_DEMOGRAPHICS = graphql(/* GraphQL */`
  query GetUserDemographics {
    getUserDemographics {
      ...DemographicsCoreFragmentAlt
    }
  }
`);

/*
 export const GET_USER_CART = gql`
 query UserCart {
 getUserCart {
 ...UserCartCoreFragment
 isWishListed @client
 ttl @client
 }
 }
 `;

 export const GET_USER_WISHLIST = gql`
 query UserWishList {
 getUserWishlist {
 ...UserWishlistCoreFragment
 isInCart @client
 }
 }
 `;
 */

export const GET_USER_EVENTS = gql`
  query UserEvents {
    getAllUserEvents {
      ...UserEventsCoreFragment
    }
  }
`;

export const GET_POTENTIAL_USER_DUPLICATES = graphql(/* GraphQL */`
  query GetUserDuplicates($searchBy: SearchByArgs) {
    getCynergyUser(searchBy: $searchBy) {
      cynergy_id
      potential_duplicates {
        __typename
        entry_id
        record_id
      }
    }
  }
`);

export const GET_ALL_USER_PAYMENT_PROFILES = graphql(/* GraphQL */`
  query PaymentProfiles($searchBy: SearchByArgs, $sort: SortingArgs, $pagination: PaginationArgs) {
    getAllPaymentProfiles(searchBy: $searchBy, sort: $sort, pagination: $pagination) {
      ... on PaymentProfiles {
        ...PaymentProfileCoreFragment
      }
    }
  }
`);

export const USER_COLLECTION = graphql(/* GraphQL */`
  query UserCollection($searchBy: SearchByArgs, $options: QueryOptionsInputType) {
    getUserCollection(searchBy: $searchBy, options: $options) {
      ...UserCollectionCoreFragment
      entries {
        ...CollectionEntryCoreFragment
      }
    }
  }
`);

export const USER_COLLECTION_ENTRIES = graphql(/* GraphQL */`
  query UserCollectionEntries($searchBy: SearchByArgs) {
    getCollectionEntries(searchBy: $searchBy) {
      ...CollectionEntryCoreFragment
      entity {
        ...ResourceReferenceCoreFragment
      }
    }
  }
`);
